import { createAction } from '@reduxjs/toolkit';

import types from '../actionTypes';

const setEditCard = createAction(types.SET_EDIT_CARD);

export { setEditCard };
